export default Object.freeze({
  EXCHANGERESULT: '교환처리내역',
  CLAIMNO: '클레임번호',
  ADJUSTMENT: '조정사유',
  MERCHANDISERETURNED: '교환반품상품',
  COMPLETE: '[재고복원완료]',
  RESTORE: '[재고복원예정]',
});
